// Capstone Project
// John, Isabel, Nick, Bobur

import React, { useState } from "react";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import APIURL from "../../../helper/environment";

const SpaceCreate = (props) => {
  const [spotNumber, setSpotNumber] = useState(0);
  const [spotDescription, setSpotDescription] = useState("");
  const [spotPricing, setSpotPricings] = useState("");
  const [spotSize, setSpotSize] = useState("");
  const [inUse, setInUse] = useState(false); // Default is false
  let parkingLot_id = props.parkingLot_id; //Assocites a Space with a given Lot

  // functions
  async function addParkingSpace(e) {
    e.preventDefault();
    let url = `${APIURL}/parking-space/add`;

    let bodyObject = {
      spotNumber: spotNumber,
      spotDescription: spotDescription,
      spotPricing: spotPricing,
      spotSize: spotSize,
      inUse: inUse,
      parkingLot_id: parkingLot_id,
    };

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", props.token); // token in header is for authorization

    const requestOptions = {
      headers: myHeaders,
      method: "POST",
      body: JSON.stringify(bodyObject),
    };

    try {
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      //props.showAllSpaces();
      props.showAllLotsSpaces();
    } catch (error) {
      console.error(error.message);
    }
  }
  return (
    <>
      <Form className="log-create" onSubmit={addParkingSpace}>
        <h3>Add a new Parking Space</h3>
        <FormGroup>
          <Label>Number:</Label>
          <Input
            type="number"
            value={spotNumber}
            onChange={(e) => setSpotNumber(e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <Label>Description:</Label>
          <Input
            type="text"
            value={spotDescription}
            onChange={(e) => setSpotDescription(e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <Label>Pricing:</Label>
          <Input
            type="text"
            value={spotPricing}
            onChange={(e) => setSpotPricings(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label>Size:</Label>
          <Input
            type="text"
            value={spotSize}
            onChange={(e) => setSpotSize(e.target.value)}
          />
        </FormGroup>
        {/* <FormGroup>
          <Label>In-Use / Reserved:</Label>
          <Input
            type="text"
            value={inUse}
            onChange={(e) => setInUse(e.target.value)}
          />
        </FormGroup> */}
        <div className="d-grid gap-2 mb-4">
          <Button type="submit" color="success">
            Add New Parking Spot
          </Button>
        </div>
      </Form>
    </>
  );
};

export default SpaceCreate;
